import getCanAddMoreSuggestionPills from '../helpers/getCanAddMoreSuggestionPills';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import { getSuggestionsSet, getSuggestionText, searchStore } from 'owa-mail-search-store';
import { SuggestionKind } from 'owa-search-service';
import { mutatorAction } from 'satcheljs';
/**
 * Sets ghost text to be used in the search box. The ghost text will be the
 * current search text + the remainder of the first suggestion.
 */
export default mutatorAction('SET_GHOST_TEXT', function setGhostText() {
    if (!isControlFeatureEnabled('sea-ghostText')) {
        return;
    }
    // Clear ghost text if user is navigating suggestions context menu.
    if (searchStore.selectedSuggestionIndex !== -1) {
        searchStore.ghostText = '';
        return;
    }
    // Clear ghost text if there's no search text.
    var searchText = searchStore.searchText;
    if (!searchText) {
        searchStore.ghostText = '';
        return;
    }
    var suggestionsSet = getSuggestionsSet();
    var isSuggestionsSetComplete = suggestionsSet && suggestionsSet.IsComplete;
    /**
     * If suggestions are incomplete, check to see if new search text is still
     * a subset of the existing ghost text. If it's not, clear the ghost text.
     * Otherwise, ghost text is still valid and doesn't need to be updated.
     */
    if (!isSuggestionsSetComplete) {
        if (searchStore.ghostText.toLocaleLowerCase().indexOf(searchText.toLocaleLowerCase()) !== 0) {
            searchStore.ghostText = '';
            return;
        }
    }
    // Clear ghost text if there's no suggestion.
    var suggestion = suggestionsSet.Suggestions[0];
    if (!suggestion) {
        searchStore.ghostText = '';
        return;
    }
    /**
     * To show ghost text, 3S QF must tell us that they have high confidence in
     * the suggestion. Since that's the case, we can only show ghost text for
     * keyword and people suggestions. Otherwise, clear ghost text.
     */
    if (!(suggestion.kind === SuggestionKind.Keywords || suggestion.kind === SuggestionKind.People)) {
        searchStore.ghostText = '';
        return;
    }
    // If service doesn't have high confidence in suggestion, clear and return.
    if (!suggestion.Attributes || !suggestion.Attributes.IsAutoCompleteHighConfidence) {
        searchStore.ghostText = '';
        return;
    }
    /**
     * If there are already the max number of pills in the search box, don't
     * suggest ghost text if the first suggestion is a type that uses pills
     * (i.e. people).
     */
    var isPillSuggestion = suggestion.kind === SuggestionKind.People;
    if (isPillSuggestion && !getCanAddMoreSuggestionPills()) {
        searchStore.ghostText = '';
        return;
    }
    // Get display text of first suggestion.
    var suggestionText = getSuggestionText(0 /* index */);
    /**
     * Ensure that searchText is a prefix of the suggestionText. If not, clear
     * the ghost text.
     */
    if (suggestionText.toLocaleLowerCase().indexOf(searchText.toLocaleLowerCase()) !== 0) {
        searchStore.ghostText = '';
        return;
    }
    /**
     * Use searchText + remainder of suggestion text because casing might
     * be inconsistent and we want to preserve user input.
     */
    searchStore.ghostText = "" + searchText + suggestionText.slice(searchText.length);
});
//# sourceMappingURL=setGhostText.js.map